var map = {
	"./admin.png": "./src/assets/backgrounds/admin.png",
	"./upgrade-estate.png": "./src/assets/backgrounds/upgrade-estate.png",
	"./upkot - Copy.png": "./src/assets/backgrounds/upkot - Copy.png",
	"./upkot.png": "./src/assets/backgrounds/upkot.png",
	"./upliving.png": "./src/assets/backgrounds/upliving.png"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/backgrounds sync recursive ^\\.\\/.*\\.png$";